// they are being used idk they aren't beinf detected by eslint
import React from "react";
import {
  BookOpenIcon,
  ClockIcon,
  CommandLineIcon,
  DocumentChartBarIcon,
} from "@heroicons/react/24/outline";
import { NavItem, RightArrow } from "./NavItem";
import { Environment } from "components/Environment/utils/types";

interface TabNavigatorProps {
  currentState?: string;
  setCurrentState: (
    state: "Logs" | "Notebook" | "Access" | "History" | "None",
  ) => void;
  environment: Environment | null;
}

const TabNavigator: React.FC<TabNavigatorProps> = ({
  currentState,
  setCurrentState,
  environment,
}) => {
  return (
    <>
      <nav aria-label="Progress">
        <ol
          role="list"
          className="divide-y border-zinc-800 md:flex md:divide-y-0 border border-2 flex justify-evenly bg-baseBg rounded-md"
        >
          <NavItem
            className="justify-center"
            label="Access"
            IconComponent={CommandLineIcon}
            onClick={() => {
              setCurrentState("Access");
            }}
            active={currentState === "Access"}
          />
          {environment && (
            <>
              <RightArrow />
            </>
          )}
          {environment &&
            environment?.build?.files &&
            environment?.build?.files.length > 0 && (
              <>
                <NavItem
                  className="justify-center"
                  label="Content"
                  IconComponent={BookOpenIcon}
                  onClick={() => {
                    setCurrentState("Notebook");
                  }}
                  active={currentState === "Notebook"}
                />
                <RightArrow />
              </>
            )}
          {environment && (
            <>
              <NavItem
                className="justify-center"
                label="Logs"
                IconComponent={DocumentChartBarIcon}
                onClick={() => {
                  setCurrentState("Logs");
                }}
                active={currentState === "Logs"}
              />
            </>
          )}
          {environment && (
            <>
              <RightArrow />
              <NavItem
                className="justify-center"
                label="History"
                IconComponent={ClockIcon}
                onClick={() => {
                  setCurrentState("History");
                }}
                active={currentState === "History"}
              />
            </>
          )}
        </ol>
      </nav>
    </>
  );
};

export default TabNavigator;
